import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import { contentfulModels, components, contentfulWidgets } from '@glowforge/ui-common';


import './materials-display.less';

const { widgetDefaultProps, widgetPropType } = contentfulModels;
const { Button } = components;
const { ButtonLinkWidget } = contentfulWidgets;

/**
 * MaterialsDisplay custom widget
 * Implemented as PureComponent to give us `shouldComponentUpdate` help.
 */
class MaterialsDisplay extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      showLeftIndicator: false,
      showRightIndicator: false,
    };

    // Throttle scroll update call to once every 300ms
    this.delayedScrollUpdate = _.throttle(this.updateScrollIndicators, 300);
  }

  // Bind onClick to the given 'index'
  onClick = index => (event) => {
    if (window.innerWidth < 960) {
      // Get center of text button within it's parent (it's offset sizing)
      const targetCenter = event.currentTarget.offsetLeft + (event.currentTarget.offsetWidth / 2);
      // Center the text button to the visible center of the parent (client width is what's visible)
      const materialsCenter = targetCenter - (this.materialsList.clientWidth / 2);
      this.materialsList.scrollTo({ left: materialsCenter, behavior: 'smooth' });
    }
    this.setState({ currentIndex: index });
  }

  // onScroll listener
  onMaterialsListScroll = (event) => {
    // persist() prevents React from flushing the event
    // we need it to stick around long enough to get through the throttle func
    event.persist();
    this.delayedScrollUpdate(event.target);
  }

  /**
   * Scroll Indicator updater
   * Used to show scroll
   * Don't call this directly, call this.delayedScrollUpdate instead
   */
  updateScrollIndicators = () => {
    const scrollElement = this.materialsList;
    if (scrollElement) {
      // Calculate padding padding around scrollElement
      const padding = (window.innerWidth - scrollElement.clientWidth) / 2;
      // Find the leftmost possible scrollLeft for the element
      const leftMax = scrollElement.scrollWidth - scrollElement.clientWidth;
      const left = scrollElement.scrollLeft;
      // Left side scroll indicator
      if (left <= padding) {
        this.setState({ showLeftIndicator: false });
      } else {
        this.setState({ showLeftIndicator: true });
      }
      // Right side scroll indicator
      if (left >= leftMax - padding) {
        this.setState({ showRightIndicator: false });
      } else {
        this.setState({ showRightIndicator: true });
      }
    }
  }

  // Hold a reference to the materialsList element to update scroll indicators
  materialsListRef = (ref) => {
    this.materialsList = ref;
    this.delayedScrollUpdate(this.materialsList);
  }

  render() {
    const {
      title: displayTitle,
      description,
      andMoreButtonProps,
      ctaProps,
      items,
    } = this.props;

    const { currentIndex } = this.state;

    const learnMoreButton = (
      <ButtonLinkWidget
        model={{ fields: ctaProps }}
        key='ctaButton'
        className='ctaButton' />
    );

    // This is the link that's visible on desktop at the end of the 'textOptions' list
    const andMoreButton = (
      <ButtonLinkWidget
        model={{ fields: andMoreButtonProps }}
        key='andMoreButton'
        className='materialOption andMoreButton' />
    );

    const textOptions = _.map(items, ({ title }, index) => (
      <Button
        key={title}
        className={`materialOption ${currentIndex === index ? 'active' : ''}`}
        type='text'
        onClick={this.onClick(index)} >
        {title}
      </Button>
    ));
    textOptions.push(andMoreButton);

    // Display the image for the currently selected material
    const image = _.get(items, `[${currentIndex}].image`);

    const { showLeftIndicator, showRightIndicator } = this.state;
    const displayClassNames = classnames('display', { showLeftIndicator }, { showRightIndicator });

    return (
      <div className='MaterialsDisplay'>
        <div className='content'>
          <h2 className='title'>{displayTitle}</h2>
          <h3 className='description'>{description}</h3>
          <div className='ctaButton'>{learnMoreButton}</div>
          <div className={displayClassNames}>
            <div
              className='materialsList'
              ref={this.materialsListRef}
              onScroll={this.onMaterialsListScroll}>
              {textOptions}
            </div>
            <div className='selectedMaterial'>{image}</div>
          </div>
        </div>
      </div>
    );
  }
}

MaterialsDisplay.propTypes = { ...widgetPropType };

MaterialsDisplay.defaultProps = { ...widgetDefaultProps };

export default MaterialsDisplay;




// WEBPACK FOOTER //
// ./app/components/landing/materials-display.jsx